import { render } from "./MkBeverage.vue?vue&type=template&id=71d8c2d0&scoped=true"
import script from "./MkBeverage.vue?vue&type=script&lang=js"
export * from "./MkBeverage.vue?vue&type=script&lang=js"

import "./MkBeverage.vue?vue&type=style&index=0&id=71d8c2d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d8c2d0"]])

export default __exports__